// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dtkQ","col":"styles_col__eF_Ks"};